var $ = require('jquery');

$(function () {
    if ($('.accordion-content').length > 0) {
        var prevAccordionFromTop = 999999;
        var prevAccordionHeight = 0;
        var curAccordionHeight = 0;
        var moduleNames = new Array(); //list of recorded module names from the querystring

        $('.accordion-content__item').on('click', function (e) {

            var aItem = $(this);
            if (aItem.data('no-collapse') !== 1) {
                //On activation click, check for other open accordions and begin to close them            
                CloseOtherAccordions(aItem, false);

                //Next, toggle the clicked tab to either open or close 
                ToggleAccordion(aItem, false);
            }
            else {   //used for the accordion items in the interests view
                $(this).children('.accordion-content__item__title').toggleClass('selected')
                    .next('.accordion-content__item__content').slideToggle({
                        start: function () { $(this).css("display", "inline-block"); }
                    });
            }
        });

        $('.accordion-content__item__content').on('click', function (e) {
            e.stopPropagation();
        });

        $('.accordion-content').each(function (i) {
            var accordionContent = $(this);
            var moduleName = accordionContent.data('module-name');
            var MoveSelectedTabToFirstElementField = $(accordionContent).data("move-selected-accordion");
            var CloseFirstAccordionPaneOnPageLoadField = $(accordionContent).data("close-first-accordion");
            var isCloseFirstPane = JSON.parse(CloseFirstAccordionPaneOnPageLoadField.toLowerCase().toString());
            var isMoveToFirstPane = JSON.parse(MoveSelectedTabToFirstElementField.toLowerCase().toString());

            var specificTabRequestedViaQueryString = true;
            var moduleIndex = $.QueryStringTabActivation(moduleName, accordionContent.find('.accordion-content__item').length);
            moduleIndex = parseInt(moduleIndex);

            //if query param is not present or querystringValue > tabCount
            if (moduleIndex === 999) {
                specificTabRequestedViaQueryString = false;
                moduleIndex = 1;
            }

            if (moduleNames.indexOf(moduleName) === -1) {
                var newAccordionTitle = accordionContent.find('.accordion-content__item__title[data-module-number="' + moduleIndex + '"]');
                var newAccordionItem = newAccordionTitle.closest('.accordion-content__item');

                //move activated accordion to top
                accordionContent.find('.accordion-content__item').removeClass('orderTop');
                newAccordionItem.addClass('orderTop');

                if (!isMoveToFirstPane) {
                    $(accordionContent).find(".orderTop").addClass("orderInherit");
                }

                //when moduleIndex =1, no need of accordion toggles as cshtml already handles it
                if (moduleIndex !== 1) {
                    //close all other accordion items
                    CloseOtherAccordions(newAccordionItem, true);

                    //toggle the activated accordion
                    //prevent accordion from activation if the condition doesnt allow it
                    if (!(isCloseFirstPane && isMoveToFirstPane) || specificTabRequestedViaQueryString) {
                        ToggleAccordion(newAccordionItem, true);
                    }
                }
                else //moduleIndex=1
                {
                    //when moduleIndex=1 present in query, handle scroll
                    if (($.QueryString[moduleName] > 0)) {
                        $.ScrollToLocation(newAccordionItem, 400, true);
                    }

                    if (isCloseFirstPane) {//if module index = 1 and isCloseFirstPane checked, hide the content area of accordion
                        if (specificTabRequestedViaQueryString) {  // unless we specifically asked for tab 1 to be open via querystring, then open it anyway
                            newAccordionTitle.addClass('selected');
                            newAccordionItem.children('.accordion-content__item__content').addClass('selected');
                        } else {
                            newAccordionItem.children('.accordion-content__item__content').slideUp();
                        }
                    }
                }

                moduleNames.push(moduleName);
            }
        });

        function CloseOtherAccordions(accordion, isPageLoad) {
            prevAccordionFromTop = 999999;
            prevAccordionHeight = 0;
            if (accordion.siblings('.accordion-content__item.selected').length > 0) {
                accordion.siblings('.accordion-content__item.selected').each(function () {
                    var openAccordion = $(this);
                    prevAccordionFromTop = openAccordion[0].offsetTop;
                    prevAccordionHeight = openAccordion.children('.accordion-content__item__content').height();
                    openAccordion.children('.accordion-content__item__content').slideToggle({
                        complete: function () {
                            openAccordion.removeClass('selected');
                            openAccordion.children('.accordion-content__item__title').removeClass('selected');
                            openAccordion.children('.accordion-content__item__content').removeClass('selected')
                                .removeAttr('style');

                            if (isPageLoad) {//on page load, scroll to the activated accordion after closing other accrodions
                                $.ScrollToLocation(accordion, 400, true);
                            }
                        }
                    });
                });
            }
            else if (isPageLoad) {//on page load, when close first accordion is checked, none of the accordions are activated. So, the scroll logic on complete of slideToggle doesnt trigger. So trigger it now.
                $.ScrollToLocation(accordion, 400, true);
            }
        }

        function ToggleAccordion(accordion, isPageLoad) {
            curAccordionHeight = 0;
            var curScrollPosition = $(window).scrollTop(); //current scroll position
            var windowHeight = $(window).height();
            var acordionItemTop = accordion.offset().top;
            var curAccordionFromTop = accordion[0].offsetTop;
            var manualOffset = 150 - (acordionItemTop - curScrollPosition);
            var adjustedScrollPosition = curScrollPosition - prevAccordionHeight - manualOffset;

            accordion.children('.accordion-content__item__content').slideToggle({
                start: function () {

                    if (isPageLoad === false) {//this part works on click events

                        curAccordionHeight = accordion.children('.accordion-content__item__content').height();
                        /*
                         Outline of conditions to activate the animation to adjust the scroll position:
                         1. The currently open accordion, which should be starting to slideUp, must be higher
                         on the page than the activated accordion item.
                         2. The combined heights of the currently open and activated accordion must be greater
                         than the height of the window.
                         3. Special Case: If the previous accordion and current accordion heights are less
                         than the window height AND the current scroll position is above the fold, the
                         scroll should activate. It should not activate if it is within the fold. Currently
                         this does not work, and the scroll activates in both cases.
                        */
                        if (prevAccordionFromTop < curAccordionFromTop) {
                            if ((curAccordionHeight + prevAccordionHeight) > windowHeight ||
                                ((curAccordionHeight + prevAccordionHeight) < windowHeight) &&
                                (curScrollPosition + 100) > prevAccordionFromTop) {
                                $.AnimatedScroll(adjustedScrollPosition, 400);
                            }
                        }
                    }
                },
                complete: function () {
                    accordion.toggleClass('selected');
                    accordion.children('.accordion-content__item__title').toggleClass('selected');
                    accordion.children('.accordion-content__item__content').toggleClass('selected').removeAttr('style');

                    //if activated accordion's top is above window's scroll position, then the accordion title will not appear in view. 
                    //This happens when activated accordion is higher than currently open accordion
                    if (accordion.offset().top < ($(window).scrollTop() + $('.header').height())) {
                        $.ScrollToLocation(accordion, 0, true);
                    }
                }
            });
        }
    }
});
